export class DocumentCenterTab {
  key
  title
  description

  constructor(documentCenterTab = {}) {
    this.key = documentCenterTab.key ? String(documentCenterTab.key) : ''
    this.title = documentCenterTab.title ? String(documentCenterTab.title) : ''
    this.description = documentCenterTab.description ? String(documentCenterTab.description) : ''
  }
}